export var stopPropagationClick = function stopPropagationClick(e) {
  e.stopPropagation();
};